import bar from './bar';
import cityDistrict from './cityDistrict';
import restaurant from './restaurant';
import wifi from './wifi';
import price from './price';
import hotelRating from './hotelRating';
import metroDistance from './metroDistance';
import beachDistance from './beachDistance';
import centerDistance from './centerDistance';
import breakfast from './breakfast';
import allInclusive from './allInclusive';
import fullBoard from './fullBoard';
import halfBoard from './halfBoard';
import adultHotel from './adultHotel';
import familyHotel from './familyHotel';
import golfHotel from './golfHotel';
import guestRating from './guestRating';
import pool from './pool';
import childrensPool from './childrensPool';

const FILTERS = {
  [bar.id]: bar,
  [cityDistrict.id]: cityDistrict,
  [restaurant.id]: restaurant,
  [wifi.id]: wifi,
  [price.id]: price,
  [hotelRating.id]: hotelRating,
  [metroDistance.id]: metroDistance,
  [beachDistance.id]: beachDistance,
  [centerDistance.id]: centerDistance,
  [breakfast.id]: breakfast,
  [allInclusive.id]: allInclusive,
  [fullBoard.id]: fullBoard,
  [halfBoard.id]: halfBoard,
  [adultHotel.id]: adultHotel,
  [familyHotel.id]: familyHotel,
  [golfHotel.id]: golfHotel,
  [guestRating.id]: guestRating,
  [pool.id]: pool,
  [childrensPool.id]: childrensPool,
};

const FILTER_QUERIES = {};

Object.keys(FILTERS).forEach((filterId) => {
  FILTER_QUERIES[filterId] = FILTERS[filterId].queryKey;
});

// eslint-disable-next-line no-useless-rename
export { FILTER_QUERIES as FILTER_QUERIES };

export default FILTERS;
